// =====================================
//
//   加入購物車特效
//   Author: Gray
//   createtime: 2016 / 04 / 18
//   updatetime: 2016 / 04 / 18
//
// =====================================

window.InifECApp.directive('flyItem', ['$rootScope', function($rootScope) {

	var _dir = {};

	var link = function(scope, element, attrs) {

        var isInit = false,
            flyItemClass = undefined,
            targetItemClass = undefined,
            flyItem = undefined,
            targetItem = undefined,
            offset = undefined,
            scrollTop = undefined,
            scrollLeft = undefined;

        var itemfly = function(event) {

            if(!isInit) {
                init();
            }

            var flyer = flyItem.clone();
            var startTop, startLeft;

            if(event) {
                startTop = event.clientY;
                startLeft = event.clientX;
            } else {
                startTop = $(element).offset().top - $(window).scrollTop();
                startLeft = $(element).offset().left - $(window).scrollLeft();
            }

            flyer.css({
                visibility: "visible"
            });
            
            flyer.fly({
                vertex_Rtop: -10,
                speed: 1.5,
                start: {
                    top: startTop,
                    left: startLeft,
                },
                end: {
                    left: offset.left,
                    top: offset.top, 
                    width: 20,
                    height: 15
                },
                onEnd: function(){
                    this.destroy();
                }
            });
        }

        var init = function() {

            flyItemClass = attrs.flyItemClass;
            targetItemClass = attrs.targetItemClass;
            flyItem = $( '.' + flyItemClass);
            targetItem = $( '.' + targetItemClass);
            offset = targetItem.offset();
            scrollTop = document.documentElement.scrollTop || document.body.scrollTop || 0;
            scrollLeft = document.documentElement.scrollLeft || document.body.scrollLeft || 0;
            offset.top -= scrollTop;
            offset.left -= scrollLeft;

            isInit = true;
        }

    	//==========================
        //  Events
        //==========================
        scope.$on('ITEM_FLY_START' , function(event, data) {
            itemfly(data.event);
        });

        scope.$on('LOGIN_SUCCESS', function(event, data) {
            isInit = false;
        })

        //==========================
        //  Members
        //==========================

        //==========================
        //  Methods
        //==========================

        //==========================
        //  Init
        //==========================

	};

	_dir.restrict = 'A';
	_dir.scope = true;
	_dir.link = link;

	return _dir;

}]);
